import { render, staticRenderFns } from "./szztkHeader.vue?vue&type=template&id=649c9c10&scoped=true&"
import script from "./szztkHeader.vue?vue&type=script&lang=js&"
export * from "./szztkHeader.vue?vue&type=script&lang=js&"
import style0 from "./szztkHeader.vue?vue&type=style&index=0&id=649c9c10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649c9c10",
  null
  
)

export default component.exports